import React from 'react';
import PropTypes from 'prop-types';
import { getRum } from '../../rum';

// Top-level error boundary that forwards React render/lifecycle errors to
// CloudWatch RUM. The SDK's built-in 'errors' telemetry only catches
// window.onerror + unhandledrejection; React swallows component errors, so
// without this boundary they never reach RUM. Renders a minimal fallback in
// place of the crashed subtree.
export default class RumErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const rum = getRum();
    if (rum) {
      rum.recordError(error);
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <div>Something went wrong.</div>;
    }
    return children;
  }
}

RumErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};
